export default function PHP_gmdate() {
  return (
    <div>
      <h1>PHP_gmdate</h1>
    </div>
  );
}
